import React, { useEffect, useState } from 'react';
import { fetchForecastData } from '../../api/data';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';

/*
TODO: Instead of loading "Current" from reportingarea data, load it from sites data instead...
      - https://cap.sonomatech.com/sites/data/siteLis
      - https://cap.sonomatech.com/sites/data/siteCurrentMax/{siteId}/0/{timestampMillis}
        - ex: https://cap.sonomatech.com/sites/data/siteCurrentMax/23669/0/1763357485731

     $region_arrays = [];
     // [0] - Eastern Shore
     // Sites: Horn Point, Blackwater NWR, Milington
     array_push($region_arrays, [23657, 23678, 23662]);

     // [1] - Metro Baltimore
     // Sites: Padonia, Essex, South Carroll, Fair Hill, Edgewood, Aldino, Lake Montebello
     // Inactive Sites: Davidsonville (23650), Oldtown (23667), Furley (23668)
     array_push($region_arrays, [23651, 23652, 23654, 23655, 23660, 23661, 27392]);

     // [2] - Metro Washington
     // Sites: River Terrace, McMilan Reservoir, Takoma Rec, Calvert, Southern Maryland, Frederick Airport,
     //        Rockville, HU-Beltsville, PG Equestrian Center, Aurora Hills, Franconia, Ashburn, James S. Long Park,
     //        Beltsville, DCNearRoad, King Greenleaf Rec Center
     // Inactive Sites: MT Vernon (23671), Annandale (23673), Lewinsville (23674), Alexandria Health (23677), McMilan NCORE (23648)
     // array_push($region_arrays, [23646, 23647, 23649, 23653, 23656, 23658, 23663, 23664,
     //                                    23665, 23669, 23672, 23675, 23676, 23683, 23704, 23711]);

     // [2] - Northern VA/DC
     // Sites: River Terrace, McMilan Reservoir, Takoma Rec, Aurora Hills, Franconia, Ashburn, James s. Long Park,
     //        King Greenleaf Rec Center
     // Inactive Sites: Northern VA Near Road ()
     array_push($region_arrays, [23646, 23647, 23649, 23669, 23672, 23675, 23676, 23711]);

     // [3] - Maryland Piedmont
     // Sites: South Carroll, Frederick Airport
     array_push($region_arrays, [23654, 23658]);

     // [4] - Northern Baltimore
     // Sites: Padonia
     array_push($region_arrays, [23651]);

     // [5] - Northeast Maryland
     // Sites: Edgewood, Aldino, Fair Hill
     array_push($region_arrays, [23660, 23661, 23655]);

     // [6] - Suburban DC
     // Sites: Rockville, HU-Beltsville, PG Equestrian Center, Beltsville
     // Inactive Sites: Howard County Near-Road (27389)
     array_push($region_arrays, [23663, 23664, 23665, 23683]);

     // [7] - Upper Eastern Shore
     // Sites: Millington
     // Inactive Sites:
     array_push($region_arrays, [23662]);

     // [8] - Southern Maryland
     // Sites: Southern Maryland, Calvert
     // Inactive Sites:
     array_push($region_arrays, [23656, 23653]);
 */


function ForecastAirQuality({ data }) {
    const [forecastData, setForecastData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchForecastData()
            .then(data => {
                setForecastData(data);
                setLoading(false);
            })
            .catch(err => {
                // TODO: Error handling
                setLoading(false);
            });
    }, []);

    if (loading) return <div key={data.documentId}>Loading...</div>;

    const createForecastIconByReportingAreaRecord = (reportingAreaRecord) => {
        let aqiCategory = "Not Available";
        if (Object.keys(reportingAreaRecord).length > 0) {
            aqiCategory = reportingAreaRecord.aqiCategory;
        }
        let forecastIcon;
        if (aqiCategory === "Good") {
            forecastIcon = data.displayIcons[0];
        } else if (aqiCategory === "Moderate") {
            forecastIcon = data.displayIcons[1];
        } else if (aqiCategory === "Unhealthy for Sensitive Groups") {
            forecastIcon = data.displayIcons[2];
        } else if (aqiCategory === "Unhealthy") {
            forecastIcon = data.displayIcons[3];
        } else if (aqiCategory === "Very Unhealthy") {
            forecastIcon = data.displayIcons[4];
        } else if (aqiCategory === "Not Available") {
            forecastIcon = data.displayIcons[6];
        } else {
            forecastIcon = data.displayIcons[4];  // Very Unhealthy for everything else
        }
        return (
            <img className="img-responsive forecast-icon"
                 alt={forecastIcon.alternativeText}
                 src={forecastIcon.url} />
        );
    };

    return (
        <div key={data.documentId} className="forecast-air-quality">
            <div className="views-row views-row-5 views-row-odd">
                <article id="node-10" className="node node-forecast-band node-promoted node-teaser clearfix"
                         about="/node/10" typeof="sioc:Item foaf:Document">
                    <div className="row background-full-width vertical-align forecast-div">
                        <div className="container forecast-container no-padding" style={{maxWidth: '1270px'}}>
                            <div className="container col-sm-12 col-xs-12 no-padding full-height vertical-align-forecast">
                                <div className="col-sm-4 full-height forecast-text">
                                    <p className="light-blue-text section-headline" align="left">
                                        Forecast
                                    </p>
                                    <p className="body-text full-width" style={{paddingBottom: '15px'}}>
                                        {data.description}</p>
                                    <a className="green-link-text"
                                       href="https://cleanairpartners.net/current-and-forecasted-air-quality"><strong>LEARN
                                        MORE</strong><img style={{height: '15px', width: '30px'}}
                                                          src="https://cleanairpartners.net/sites/default/files/03%20ui%20elements/linkarrow.svg"/></a>
                                </div>

                                {/* Extra Small Screens Only */}
                                <div className="col-xs-12 d-block d-sm-none no-padding full-height blue-gradient vertical-align" style={{paddingBottom: '10px'}}>
                                    <table className="white-text forecast-table-mobile">
                                        <tbody>
                                        <tr>
                                            <th></th>
                                            <th>CURRENT AIR QUALITY</th>
                                            <th>TODAY'S FORECAST</th>
                                            <th>TOMORROW'S FORECAST</th>
                                        </tr>
                                        <tr>
                                            <th>NORTHERN VIRGINIA / WASHINGTON</th>
                                            <td className="forecast-cell-top-left">
                                                { createForecastIconByReportingAreaRecord( forecastData['northern_virginia_max']['current'] ) }
                                            </td>
                                            <td className="forecast-cell-top-center">
                                                { createForecastIconByReportingAreaRecord( forecastData['northern_virginia_max']['today_forecast'] ) }
                                            </td>
                                            <td className="forecast-cell-top-right">
                                                { createForecastIconByReportingAreaRecord( forecastData['northern_virginia_max']['tomorrow_forecast'] ) }
                                            </td>
                                        </tr>

                                        <tr>
                                            <th>METRO BALTIMORE</th>
                                            <td className="forecast-cell-center-left">
                                                { createForecastIconByReportingAreaRecord( forecastData['metro_baltimore_max']['current'] ) }
                                            </td>
                                            <td className="forecast-cell-center">
                                                { createForecastIconByReportingAreaRecord( forecastData['metro_baltimore_max']['today_forecast'] ) }
                                            </td>
                                            <td className="forecast-cell-center-right">
                                                { createForecastIconByReportingAreaRecord( forecastData['metro_baltimore_max']['tomorrow_forecast'] ) }
                                            </td>
                                        </tr>

                                        <tr>
                                            <th>MARYLAND PIEDMONT</th>
                                            <td className="forecast-cell-center-left">
                                                { createForecastIconByReportingAreaRecord( forecastData['maryland_piedmont_max']['current'] ) }
                                            </td>
                                            <td className="forecast-cell-center">
                                                { createForecastIconByReportingAreaRecord( forecastData['maryland_piedmont_max']['today_forecast'] ) }
                                            </td>
                                            <td className="forecast-cell-center-right">
                                                { createForecastIconByReportingAreaRecord( forecastData['maryland_piedmont_max']['tomorrow_forecast'] ) }
                                            </td>
                                        </tr>

                                        <tr>
                                            <th>NORTHERN BALTIMORE</th>
                                            <td className="forecast-cell-center-left">
                                                { createForecastIconByReportingAreaRecord( forecastData['northern_baltimore_max']['current'] ) }
                                            </td>
                                            <td className="forecast-cell-center">
                                                { createForecastIconByReportingAreaRecord( forecastData['northern_baltimore_max']['today_forecast'] ) }
                                            </td>
                                            <td className="forecast-cell-center-right">
                                                { createForecastIconByReportingAreaRecord( forecastData['northern_baltimore_max']['tomorrow_forecast'] ) }
                                            </td>
                                        </tr>

                                        <tr>
                                            <th>NORTHEAST MARYLAND</th>
                                            <td className="forecast-cell-center-left">
                                                { createForecastIconByReportingAreaRecord( forecastData['northeast_maryland_max']['current'] ) }
                                            </td>
                                            <td className="forecast-cell-center">
                                                { createForecastIconByReportingAreaRecord( forecastData['northeast_maryland_max']['today_forecast'] ) }
                                            </td>
                                            <td className="forecast-cell-center-right">
                                                { createForecastIconByReportingAreaRecord( forecastData['northeast_maryland_max']['tomorrow_forecast'] ) }
                                            </td>
                                        </tr>

                                        <tr>
                                            <th>SUBURBAN DC</th>
                                            <td className="forecast-cell-center-left">
                                                { createForecastIconByReportingAreaRecord( forecastData['suburban_dc_max']['current'] ) }
                                            </td>
                                            <td className="forecast-cell-center">
                                                { createForecastIconByReportingAreaRecord( forecastData['suburban_dc_max']['today_forecast'] ) }
                                            </td>
                                            <td className="forecast-cell-center-right">
                                                { createForecastIconByReportingAreaRecord( forecastData['suburban_dc_max']['tomorrow_forecast'] ) }
                                            </td>
                                        </tr>

                                        <tr>
                                            <th>UPPER EASTERN SHORE</th>
                                            <td className="forecast-cell-center-left">
                                                { createForecastIconByReportingAreaRecord( forecastData['upper_eastern_shore_max']['current'] ) }
                                            </td>
                                            <td className="forecast-cell-center">
                                                { createForecastIconByReportingAreaRecord( forecastData['upper_eastern_shore_max']['today_forecast'] ) }
                                            </td>
                                            <td className="forecast-cell-center-right">
                                                { createForecastIconByReportingAreaRecord( forecastData['upper_eastern_shore_max']['tomorrow_forecast'] ) }
                                            </td>
                                        </tr>

                                        <tr>
                                            <th>SOUTHERN MARYLAND</th>
                                            <td className="forecast-cell-bottom-left">
                                                { createForecastIconByReportingAreaRecord( forecastData['southern_maryland_max']['current'] ) }
                                            </td>
                                            <td className="forecast-cell-bottom-center">
                                                { createForecastIconByReportingAreaRecord( forecastData['southern_maryland_max']['today_forecast'] ) }
                                            </td>
                                            <td className="forecast-cell-bottom-right">
                                                { createForecastIconByReportingAreaRecord( forecastData['southern_maryland_max']['tomorrow_forecast'] ) }
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <span className="d-block d-sm-none">
                                    <img className="full-width" style={{minHeight: '35px'}} src={ data.displayIcons[5].url } />
                                </span>

                                {/* Small Screens Or Bigger */}
                                <div className="col-sm-8 d-none d-sm-block no-padding blue-gradient forecast-display">
                                    <div className="vertical-align forecast-display">
                                        <div className="col-sm-12" id="forecastTable">
                                            <table className="white-text" style={{width: '100%'}}>
                                                <tbody>
                                                <tr>
                                                    <th></th>
                                                    <th>CURRENT AIR QUALITY</th>
                                                    <th>TODAY'S FORECAST</th>
                                                    <th>TOMORROW'S FORECAST</th>
                                                </tr>
                                                <tr>
                                                    <th>NORTHERN VIRGINIA / WASHINGTON</th>
                                                    <td className="forecast-cell-top-left">
                                                        { createForecastIconByReportingAreaRecord( forecastData['northern_virginia_max']['current'] ) }
                                                    </td>
                                                    <td className="forecast-cell-top-center">
                                                        { createForecastIconByReportingAreaRecord( forecastData['northern_virginia_max']['today_forecast'] ) }
                                                    </td>
                                                    <td className="forecast-cell-top-right">
                                                        { createForecastIconByReportingAreaRecord( forecastData['northern_virginia_max']['tomorrow_forecast'] ) }
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>METRO BALTIMORE</th>
                                                    <td className="forecast-cell-center-left">
                                                        { createForecastIconByReportingAreaRecord( forecastData['metro_baltimore_max']['current'] ) }
                                                    </td>
                                                    <td className="forecast-cell-center">
                                                        { createForecastIconByReportingAreaRecord( forecastData['metro_baltimore_max']['today_forecast'] ) }
                                                    </td>
                                                    <td className="forecast-cell-center-right">
                                                        { createForecastIconByReportingAreaRecord( forecastData['metro_baltimore_max']['tomorrow_forecast'] ) }
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>MARYLAND PIEDMONT</th>
                                                    <td className="forecast-cell-center-left">
                                                        { createForecastIconByReportingAreaRecord( forecastData['maryland_piedmont_max']['current'] ) }
                                                    </td>
                                                    <td className="forecast-cell-center">
                                                        { createForecastIconByReportingAreaRecord( forecastData['maryland_piedmont_max']['today_forecast'] ) }
                                                    </td>
                                                    <td className="forecast-cell-center-right">
                                                        { createForecastIconByReportingAreaRecord( forecastData['maryland_piedmont_max']['tomorrow_forecast'] ) }
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>NORTHERN BALTIMORE</th>
                                                    <td className="forecast-cell-center-left">
                                                        { createForecastIconByReportingAreaRecord( forecastData['northern_baltimore_max']['current'] ) }
                                                    </td>
                                                    <td className="forecast-cell-center">
                                                        { createForecastIconByReportingAreaRecord( forecastData['northern_baltimore_max']['today_forecast'] ) }
                                                    </td>
                                                    <td className="forecast-cell-center-right">
                                                        { createForecastIconByReportingAreaRecord( forecastData['northern_baltimore_max']['tomorrow_forecast'] ) }
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>NORTHEAST MARYLAND</th>
                                                    <td className="forecast-cell-center-left">
                                                        { createForecastIconByReportingAreaRecord( forecastData['northeast_maryland_max']['current'] ) }
                                                    </td>
                                                    <td className="forecast-cell-center">
                                                        { createForecastIconByReportingAreaRecord( forecastData['northeast_maryland_max']['today_forecast'] ) }
                                                    </td>
                                                    <td className="forecast-cell-center-right">
                                                        { createForecastIconByReportingAreaRecord( forecastData['northeast_maryland_max']['tomorrow_forecast'] ) }
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>SUBURBAN DC</th>
                                                    <td className="forecast-cell-center-left">
                                                        { createForecastIconByReportingAreaRecord( forecastData['suburban_dc_max']['current'] ) }
                                                    </td>
                                                    <td className="forecast-cell-center">
                                                        { createForecastIconByReportingAreaRecord( forecastData['suburban_dc_max']['today_forecast'] ) }
                                                    </td>
                                                    <td className="forecast-cell-center-right">
                                                        { createForecastIconByReportingAreaRecord( forecastData['suburban_dc_max']['tomorrow_forecast'] ) }
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>UPPER EASTERN SHORE</th>
                                                    <td className="forecast-cell-center-left">
                                                        { createForecastIconByReportingAreaRecord( forecastData['upper_eastern_shore_max']['current'] ) }
                                                    </td>
                                                    <td className="forecast-cell-center">
                                                        { createForecastIconByReportingAreaRecord( forecastData['upper_eastern_shore_max']['today_forecast'] ) }
                                                    </td>
                                                    <td className="forecast-cell-center-right">
                                                        { createForecastIconByReportingAreaRecord( forecastData['upper_eastern_shore_max']['tomorrow_forecast'] ) }
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>SOUTHERN MARYLAND</th>
                                                    <td className="forecast-cell-bottom-left">
                                                        { createForecastIconByReportingAreaRecord( forecastData['southern_maryland_max']['current'] ) }
                                                    </td>
                                                    <td className="forecast-cell-bottom-center">
                                                        { createForecastIconByReportingAreaRecord( forecastData['southern_maryland_max']['today_forecast'] ) }
                                                    </td>
                                                    <td className="forecast-cell-bottom-right">
                                                        { createForecastIconByReportingAreaRecord( forecastData['southern_maryland_max']['tomorrow_forecast'] ) }
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <span>
                                        <img className="full-width" src={ data.displayIcons[5].url } />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </article>
            </div>
        </div>
    );
}

export default ForecastAirQuality;
